import { render, staticRenderFns } from "./MemberLogin.vue?vue&type=template&id=fda66da0&scoped=true"
import script from "./MemberLogin.vue?vue&type=script&lang=js"
export * from "./MemberLogin.vue?vue&type=script&lang=js"
import style0 from "./MemberLogin.vue?vue&type=style&index=0&id=fda66da0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda66da0",
  null
  
)

export default component.exports